import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentOriginatorsAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentOrginator`,
    method: 'get',
  });
};

export type ShipmentOriginatorsResponse = {
  shipmentOriginator: string;
  shipmentOriginatorID: string;
}[];

export const fetchShipmentOriginators = async (): Promise<ShipmentOriginatorsResponse> => {
  const response: AxiosResponse<ShipmentOriginatorsResponse> = await getShipmentOriginatorsAPI();
  return response.data;
};
